import type { ToastOptions, TypeOptions } from 'react-toastify/dist/types';

import * as Sentry from '@sentry/react';
import { toast } from 'react-toastify';

import { toastContent } from '../components/elements/Toasts';
import toastMessages from '../components/elements/Toasts/toastMessages';

const handleCommonToast = (
  type: TypeOptions,
  code?: string,
  options: ToastOptions = {},
  error?: Error
) => {
  if (error) {
    Sentry.captureException(error);
  }

  const message = toastMessages[type][String(code)];
  if (!message) {
    console.error(`Unknown ${type} message type: `, code);
    toast(toastContent(type, toastMessages[type]['Unknown']), {
      type: type,
      ...options,
    });
    return;
  }
  toast(toastContent(type, message), {
    type: type,
    ...options,
  });
};

export default handleCommonToast;
